import { UPLOAD } from '../actions/upload';
import { CANCEL_UPLOADS } from '../actions/cancel-uploads';

export default function uploadMiddleware(uploadFile, requestCredentials, request) {
  let requests = [];
  const removeFinishedRequests = () => {
    requests = requests.filter(xhr => xhr.readystate !== 4);
  };

  return store => next => action => {
    switch (action.type) {
      case UPLOAD: {
        const { file, type, onSuccess } = action.payload;

        return requestCredentials(request, type)
          .then(credentials => {
            const { xhr, promise } = uploadFile(file, type, credentials);
            requests.push(xhr);
            return promise;
          })
          .then(file => store.dispatch(onSuccess(file)))
          .then(removeFinishedRequests)
          .catch(removeFinishedRequests);
      }

      case CANCEL_UPLOADS: {
        requests.forEach(xhr => {
          xhr.abort();
        });
        requests = [];
        return Promise.resolve();
      }

      default:
        return next(action);
    }
  };
}



// WEBPACK FOOTER //
// ./app/middleware/upload-middleware.js